function initSalesForm(formElement) {
  const submit = formElement.querySelector("button[type='submit']");

  toastr.options.positionClass = 'toast-bottom-center';

  renderReCaptcha(formElement, function (widgetId) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', formElement.getAttribute('action'));
    xhr.send(new FormData(formElement));

    xhr.onload = function () {
      if (xhr.status === 200) {
        let response = JSON.parse(xhr.responseText);
        if (response.ok) {
          showMessage(response.message,'success');
          grecaptcha.reset(widgetId);
          formElement.reset();
          return;
        } else {
          showMessage(response.message, 'warning');
        }
      }

      grecaptcha.reset(widgetId);
      showMessage('error');
    };

    xhr.onerror = function () {
      showMessage(JSON.parse(xhr.responseText),'error');
      grecaptcha.reset(widgetId);
      submit.removeAttribute('disabled');
    };
  });
}

function showMessage (message, type) {
  toastr[type](message);
}
